define({
    INITIALISATION_MESSAGE_TYPE: "initialisation",
    FONT_QUERY_MESSAGE_TYPE: "fontQuery"
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/psdImport/PSDImportConstants.js